import React from 'react';
import { useParams } from 'react-router';
import { useLocation } from 'react-router-dom';

import BasicTitle from './BasicTitle.js';
import MonitorsBarContent from './MonitorsBarContent.js';
import PatientProfileBarContent from './PatientProfileBarContent.js';
import PatientsBarContent from './PatientsBarContent.js';
import StreamsBarContent from './StreamsBarContent.js';
enum PATHS {
  HOME = '/',
  STREAMS = '/streams',
  PATIENTS = '/patients',
  CAMERAS = '/cameras',
  ROUTERS = '/routers',
  CODES = '/codes',
  LOGS = '/logs',
  MONITORS = '/monitors',
}
enum PATHS_BASIC {
  NEW = '/new',
  UPDATE = '/update',
}
enum PATHS_PATIENTS {
  LOGS = '/logs',
  MONITORING_HOURS = '/monitoring-hours',
}

const AppBarContent = () => {
  const { pathname } = useLocation();
  const { patientId } = useParams();

  if (pathname === PATHS.HOME) {
    return <BasicTitle text={'Welcome to the Care Center'} />;
  }

  if (pathname === PATHS.STREAMS) {
    return <StreamsBarContent />;
  }

  if (pathname.includes(PATHS.PATIENTS)) {
    if (pathname.includes(PATHS_BASIC.NEW)) {
      return <BasicTitle text={'Create a new patient'} />;
    }
    if (patientId) {
      if (pathname.includes(PATHS_BASIC.UPDATE)) {
        return <PatientProfileBarContent isUpdating />;
      }
      if (pathname.includes(PATHS_PATIENTS.LOGS)) {
        return <PatientProfileBarContent isViewingLogs />;
      }
      return <PatientProfileBarContent />;
    }

    return <PatientsBarContent />;
  }

  if (pathname.includes(PATHS.CAMERAS)) {
    return <BasicTitle text={'Cameras'} />;
  }

  if (pathname.includes(PATHS.ROUTERS)) {
    return <BasicTitle text={'Routers'} />;
  }

  if (pathname.includes(PATHS.CODES)) {
    return <BasicTitle text={'Codes & Categories'} />;
  }
  if (pathname.includes(PATHS.LOGS)) {
    return <BasicTitle text={'Logs & Reports'} />;
  }
  if (pathname.includes(PATHS.MONITORS)) {
    if (pathname === PATHS.MONITORS){
      return <MonitorsBarContent/>;
    }
    return <MonitorsBarContent isUpating />;
  }
  return <div />;
};

export default AppBarContent;
